<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">MyApplication</div>
          <div class="panal-body">
            <div class="row">
              <div class="col-md-10 col-sm-12">
                <div class="row">
                  <div class="col-md-3 col-sm-12">
                    <div class="profileData">Student Name :</div>
                  </div>
                  <div class="col-md-9 col-sm-12">
                    <div class="profileData2">
                      {{ ApplicantDataList.FirstNameEN }}
                      {{ ApplicantDataList.SecondNameEN }}
                      {{ ApplicantDataList.ThirdNameEN }}
                      {{ ApplicantDataList.LastNameEN }}
                      {{ ApplicantDataList.FamilyNameEN }}
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-12">
                    <div class="profileData">Applicant Code</div>
                  </div>
                  <div class="col-md-3 col-sm-12">
                    <div class="profileData2">
                      {{ ApplicantDataList.Username }}
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-12">
                    <div class="profileData">National Id</div>
                  </div>
                  <div class="col-md-3 col-sm-12">
                    <div class="profileData2">
                      {{ ApplicantDataList.NationID }}
                    </div>
                  </div>


                    <div class="col-md-3 col-sm-12">
                    <div class="profileData">Gender</div>
                  </div>
                  <div class="col-md-3 col-sm-12">
                    <div class="profileData2">
                   {{ ApplicantDataList.ReligionNameEN }}
                    </div>
                  </div>

               <div class="col-md-3 col-sm-12">
                    <div class="profileData"> Nationalty</div>
                  </div>
                  <div class="col-md-3 col-sm-12">
                    <div class="profileData2">
                {{ ApplicantDataList.NationalityNameEN }}
                    </div>
                  </div>


           
                </div>
              </div>
              <div class="col-md-2 col-sm-12">
                <div class="app-stu-photo">
                  <img src="../../assets/SU_Logo.png" />
                </div>
              </div>
            </div>

            <div class="clearfix"></div>

            <div class="table-responsive">
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Adress</th>
                    <th scope="col">IS Primary</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(email, index) in ApplicantDataList.ApplicantAddress"
                    v-bind:key="email.serial"
                  >
                    <th scope="row">{{ index + 1 }}</th>
                    <td>
                      {{ email.CountryNameEN }}-{{ email.GovernorateNameEN }}-
                      {{ email.Address }}
                    </td>
                    <td v-if="email.IsPrimary">
                      <b-icon-check2-circle
                        class="text-success"
                      ></b-icon-check2-circle>
                    </td>
                    <td v-else></td>
                  </tr>
                </tbody>
              </table>
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Email</th>
                    <th scope="col">IS Primary</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(email, index) in ApplicantDataList.ApplicantEmails"
                    v-bind:key="email.serial"
                  >
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ email.ContactDetails }}</td>
                    <td v-if="email.IsPrimary">
                      <b-icon-check2-circle
                        class="text-success"
                      ></b-icon-check2-circle>
                    </td>
                    <td v-else></td>
                  </tr>
                </tbody>
              </table>
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Phone</th>
                    <th scope="col">IS Primary</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(phone, index) in ApplicantDataList.ApplicantPhones"
                    v-bind:key="phone.serial"
                  >
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ phone.ContactDetails }}</td>
                    <td v-if="phone.IsPrimary">
                      <b-icon-check2-circle
                        class="text-success"
                      ></b-icon-check2-circle>
                    </td>
                    <td v-else></td>
                  </tr>
                </tbody>
              </table>
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">CERTIFICATION</th>
                    <th scope="col">SPECIALIZATION</th>
                    <th scope="col">PERCENTAGE</th>
                    <th scope="col">DEGREE</th>
                    <th scope="col">CERTIFICATION YEAR</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(cert, index) in ApplicantDataList.CerificationData"
                    v-bind:key="cert.serial"
                  >
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ cert.CertificationNameEN }}</td>
                    <td>{{ cert.SpecializationNameEN }}</td>
                    <td>{{ cert.Percentage }}</td>
                    <td>{{ cert.Degree }}</td>
                    <td>{{ cert.Year }}</td>
                  </tr>
                </tbody>
              </table>

              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">PREFERENCE</th>
                    <th scope="col" width="10%">SEMESTER</th>
                    <th scope="col" width="10%">CAMPUS</th>
                    <th scope="col" width="25%">FACULTY</th>
                    <th scope="col">ENROLLMENT STATUS</th>
                    <th scope="col">APPLICATION DATE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr></tr>
                  <tr
                    v-for="(pref, index) in ApplicantDataList.Applications"
                    v-bind:key="pref.serial"
                  >
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ pref.PreferenceNameEN }}</td>
                    <td>{{ pref.SemesterName }}</td>
                    <td>{{ pref.BrancheNameEN }}</td>
                    <td>{{ pref.FacultyNameEN }}</td>
                    <td>{{ pref.ApplicantStatusEN }}</td>
                    <td>{{ pref.ApplicantDate | moment("ll") }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="text-right">
              <button
                type="button"
                class="btn btn-primary mr-1"
                @click="$router.push('Exam')"
              >
                Choose Exam
              </button>
              <!-- <button type="button" class="btn btn-success">Print</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApplicantDataServices from "../../services/Applicant/ApplicantData.services";
export default {
  data() {
    return {
      ApplicantDataList: [],
      submitted: false,
      renderdata: false,
    };
  },

  beforeMount() {
    //this.GetApplication()
  },
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },

    reviewApplication() {
      return this.$store.state.auth.renderReview;

      //   return this.getApplication()
    },
  },
  mounted() {
    this.GetApplication();
  },
  methods: {
    GetApplication() {
      ApplicantDataServices.GetAllApplicantDataList(
        this.currenUser.UserIDSerial
      ).then(
        (Response) => {
          this.ApplicantDataList = Response.data;
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();
          if (error.response.status == 404) this.message = "";
        }
      );
    },
  },
  created() {},
};
</script>

<style scoped>
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #d4d4d4;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
}
.panal-header {
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  margin-bottom: 20px !important;
}

.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef !important;
  border-color: #dee2e6 !important;
  font-size: 13px;
}
.panal-body {
  padding: 20px;
  color: #333;
}

.app-stu-photo {
  float: right;

  border-radius: 10px;
  border: 1px solid #111;
 
}

.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}

.app-All {
  width: 60%;
  float: left;
}

.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}

.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-dark th {
  color: #fff;
  background-color: #dee2e6 !important;
  border-color: #989899 !important;
  font-size: 13px !important;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
  font-size: 13px !important;
}

@media only screen and (max-width: 600px) {
  .panal-header {
    width: 90% !important;
  }
  .app-stu-photo {
    float: none !important;
  }
}

.profileData,
.profileData2 {
  border: 1px dotted #646464;
  padding: 3px 10px;
  font-weight: 700;
  margin: 5px 0px;
}
.profileData {
  color: #285475;
}
.profileData2 {
  color: #ff8600;
}
</style>